var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useTypeSelector } from '../../../hooks/useTypeHooks';
import { createSelector } from '@reduxjs/toolkit';
import styles from './Positions.module.scss';
import { useSelector } from 'react-redux';
import { selectMatrixPreferences } from '../../../Redux/selectors/selectors';
var memoSelector = createSelector([
    function (state) { return state.view.trace; },
    function (state) { return state.view.table; },
    function (state) { return state.view.activeQueryTraceIndex; },
    function (state) { return state.trainer.tables[0].table; },
    function (state) { return state.trainer.tables[0].activePlayer; },
], function (trace, table, activeQueryTraceIndex, trainerTable, activePlayer) {
    return ({
        trace: trace,
        table: table,
        activeQueryTraceIndex: activeQueryTraceIndex,
        trainerTable: trainerTable,
        activePlayer: activePlayer,
    });
});
var Positions = function (_a) {
    var _b;
    var _c = _a.source, source = _c === void 0 ? '' : _c;
    var _d = useTypeSelector(memoSelector), trace = _d.trace, table = _d.table, activeQueryTraceIndex = _d.activeQueryTraceIndex, trainerTable = _d.trainerTable, activePlayer = _d.activePlayer;
    var potPositionsLine = useSelector(selectMatrixPreferences).potPositionsLine;
    var players = source === 'trainer' ? trainerTable.players : table.players;
    var activeCard = activeQueryTraceIndex === -1 ? trace.findIndex(function (card) { return card.is_active; }) : activeQueryTraceIndex;
    var selectedPosition = source === 'trainer' ? activePlayer : (_b = trace[activeCard]) === null || _b === void 0 ? void 0 : _b.player;
    return (_jsxs("div", __assign({ className: potPositionsLine ? styles.positionsContainer : styles.positionsContainerHidden, style: { overflow: !source ? 'hidden' : 'visible' } }, { children: [!source && (_jsxs("div", __assign({ className: styles.stackCard }, { children: [_jsxs("span", { children: [table.main_pot.toFixed(2), "bb"] }), _jsxs("span", { children: [table.pot.toFixed(2), "bb"] })] }))), players.map(function (player) { return (_jsxs("div", __assign({ className: styles.positionCard, style: {
                    opacity: player.is_fold ? 0.3 : 1,
                    outline: selectedPosition === player.name ? '1px solid var(--border_green)' : 'none',
                } }, { children: [_jsx("span", { children: player.name }), _jsx("span", { children: player.stack.toFixed(2) })] }), player.name)); })] })));
};
export default Positions;
